import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { Constants } from '@config/constants';
import { HttpClient } from '@angular/common/http';
import { catchError, retry } from 'rxjs/operators';

import { IMachineFromApi, IMachineForSettings } from 'app/models';
import { ErrorHandlingService } from '../error-handling/error.handling.service';

@Injectable()
export class MachineService {
  constructor(
    private readonly http: HttpClient,
    private readonly constants: Constants,
    private readonly errorHandlingService: ErrorHandlingService
  ) { }

  findAllMachinesByCustomer = (
    customerId: number
  ): Observable<IMachineFromApi[]> =>
    this.http
      .get<IMachineFromApi[]>(
        this.constants.MACHINES_ENDPOINT + `?customerId=${customerId}`
      )
      .pipe(
        retry(this.constants.HTTP_REQUEST_RETRY_TIMES),
        catchError(this.errorHandlingService.handleHttpError)
      );

  findAllMachinesByCustomerAndLabel = (
    customerId: number,
    type: string,
    code: string,
  ): Observable<IMachineFromApi[]> =>
    this.http
      .get<IMachineFromApi[]>(
        this.constants.MACHINES_ENDPOINT
        + `?customerId=${customerId}`
        + `&type=${type}`
        + `&code=${code}`
      )
      .pipe(
        retry(this.constants.HTTP_REQUEST_RETRY_TIMES),
        catchError(this.errorHandlingService.handleHttpError)
      );

  findAllMachines = (): Observable<IMachineFromApi[]> =>
    this.http
      .get<IMachineFromApi[]>(this.constants.MACHINES_ENDPOINT)
      .pipe(
        retry(this.constants.HTTP_REQUEST_RETRY_TIMES),
        catchError(this.errorHandlingService.handleHttpError)
      );

  findAllMachinesForSettings = (): Observable<IMachineForSettings[]> =>
    this.http
      .get<IMachineForSettings[]>(this.constants.MACHINES_ENDPOINT)
      .pipe(
        retry(this.constants.HTTP_REQUEST_RETRY_TIMES),
        catchError(this.errorHandlingService.handleHttpError)
      );

  findMachineById = (
    id: number
  ): Observable<IMachineFromApi> =>
    this.http
      .get<IMachineFromApi>(
        this.constants.MACHINES_ENDPOINT + `/${id}`
      )
      .pipe(
        retry(this.constants.HTTP_REQUEST_RETRY_TIMES),
        catchError(this.errorHandlingService.handleHttpError)
      );

  addMachine = (
    paramsToUpdate: Partial<IMachineFromApi>
  ): Observable<IMachineFromApi> =>
    this.http
      .post<IMachineFromApi>(this.constants.MACHINES_ENDPOINT, paramsToUpdate)
      .pipe(
        retry(this.constants.HTTP_REQUEST_RETRY_TIMES),
        catchError(this.errorHandlingService.handleHttpError)
      );

  deleteMachine = (id: number): Observable<void> =>
    this.http
      .delete<void>(this.constants.MACHINES_ENDPOINT + `/${id}`)
      .pipe(
        retry(this.constants.HTTP_REQUEST_RETRY_TIMES),
        catchError(this.errorHandlingService.handleHttpError)
      );

  updateMachine = (
    id: number,
    paramsToUpdate: Partial<IMachineFromApi>
  ): Observable<IMachineFromApi> =>
    this.http
      .patch<IMachineFromApi>(
        this.constants.MACHINES_ENDPOINT + `/${id}`,
        paramsToUpdate
      )
      .pipe(
        retry(this.constants.HTTP_REQUEST_RETRY_TIMES),
        catchError(this.errorHandlingService.handleHttpError)
      );
}
